module.exports = __webpack_public_path__ + "static/img/news112.1af03eda.png";